module.exports = __webpack_public_path__ + "static/img/faq.be2dc717.png";